import { Injectable } from '@angular/core';
import { RoutingConfigService } from '@openmfp/portal-ui-lib';

@Injectable()
export class DxpRoutingConfigServiceImpl implements RoutingConfigService {
  getRoutingConfig(): any {
    return {
      pageNotFoundHandler: () => {
        return {
          redirectTo: 'error/404',
          keepURL: true,
        };
      },
    };
  }
}
